import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import MrpDashboard from './components/MrpDashboard';
import MrpJobs from './components/MrpJobs';
import MrpStations from './components/MrpStations';
import MrpJobTracker from './components/MrpJobTracker';
import MrpStationWork from './components/MrpStationWork';
import MrpReports from './components/MrpReports';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import Access from "constants/Access";

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, userAccess}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={match.url}>
				{userAccess <= Access.Manager
					? <MrpDashboard/>
					: <Redirect to={`${match.url}/job-tracker`}/>}
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute exact path={`${match.url}/work`}>
				<MrpStationWork/>
			</ErrorBoundaryRoute>

			{userAccess <= Access.Supervisor && (
				<ErrorBoundaryRoute exact path={`${match.url}/jobs`}>
					<MrpJobs/>
				</ErrorBoundaryRoute>
			)}

			{userAccess <= Access.Employee && (
				<ErrorBoundaryRoute exact path={`${match.url}/job-tracker`}>
					<MrpJobTracker/>
				</ErrorBoundaryRoute>
			)}

			{userAccess <= Access.Manager && (
				<ErrorBoundaryRoute exact path={`${match.url}/reports`}>
					<MrpReports/>
				</ErrorBoundaryRoute>
			)}

			{userAccess <= Access.Manager && (
				<ErrorBoundaryRoute exact path={`${match.url}/stations`}>
					<MrpStations/>
				</ErrorBoundaryRoute>
			)}

			<ErrorBoundaryRoute>
				<Redirect to={match.url}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
